import type { ContractAcceptanceRecord, ContractDoc, ContractSettings } from "@/types";
import { apiClient } from "./client";

export const contractService = {
  settings: async (propertyId: string): Promise<ContractSettings> => {
    const { data } = await apiClient.get<ContractSettings>("/admin/contracts", {
      params: { property_id: propertyId },
    });
    return data;
  },

  setRequired: async (propertyId: string, required: boolean): Promise<ContractSettings> => {
    const { data } = await apiClient.put<ContractSettings>(
      "/admin/contracts/settings",
      { required },
      { params: { property_id: propertyId } }
    );
    return data;
  },

  upsert: async (propertyId: string, language: string, body: string): Promise<ContractDoc> => {
    const { data } = await apiClient.put<ContractDoc>(
      `/admin/contracts/${language}`,
      { body },
      { params: { property_id: propertyId } }
    );
    return data;
  },

  remove: async (propertyId: string, language: string): Promise<void> => {
    await apiClient.delete(`/admin/contracts/${language}`, {
      params: { property_id: propertyId },
    });
  },

  acceptances: async (propertyId: string): Promise<ContractAcceptanceRecord[]> => {
    const { data } = await apiClient.get<ContractAcceptanceRecord[]>(
      "/admin/contracts/acceptances",
      { params: { property_id: propertyId } }
    );
    return data;
  },

  /** 체결본 내려받기 — 게스트 링크가 만료된 뒤의 교부 창구. */
  downloadAcceptance: async (propertyId: string, acceptanceId: string): Promise<void> => {
    const { data } = await apiClient.get<Blob>(
      `/admin/contracts/acceptances/${acceptanceId}/document`,
      { params: { property_id: propertyId }, responseType: "blob" }
    );
    // 파일명은 서버와 같은 규칙으로 조립한다 — Content-Disposition 을 파싱할 이유가 없다.
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `contract-acceptance-${acceptanceId}.md`;
    a.click();
    URL.revokeObjectURL(url);
  },
};
